export function tagMapper(tag) {
  //deal with v3 and v4 payloads
  tag.avatarImage = tag.images?.preview
    ? updateQueryParameters(tag.images.preview, {width: 500, height: 500, crop: 'fit', rotate: tag.images.rotation})
    : tag.images?.medium?.url;

  tag.user_id = tag.user_id || tag.user?.id;
  return tag;
}
